const divIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_475_21)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1829 1.53659H2.81707C2.10988 1.53659 1.53659 2.10988 1.53659 2.81707V18.1829C1.53659 18.8901 2.10988 19.4634 2.81707 19.4634H18.1829C18.8901 19.4634 19.4634 18.8901 19.4634 18.1829V2.81707C19.4634 2.10988 18.8901 1.53659 18.1829 1.53659ZM2.81707 0C1.26125 0 0 1.26125 0 2.81707V18.1829C0 19.7388 1.26125 21 2.81707 21H18.1829C19.7388 21 21 19.7388 21 18.1829V2.81707C21 1.26125 19.7388 0 18.1829 0H2.81707Z"
        fill="#6B00DF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.44 8.61538H5.56V12.3846H15.44V8.61538ZM5.56 7C4.69844 7 4 7.72323 4 8.61538V12.3846C4 13.2768 4.69844 14 5.56 14H15.44C16.3016 14 17 13.2768 17 12.3846V8.61538C17 7.72323 16.3016 7 15.44 7H5.56Z"
        fill="#6B00DF"
      />
    </g>
    <defs>
      <clipPath id="clip0_475_21">
        <rect width="21" height="21" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default divIcon;
